angular.module( 'acme.view.application.modals.save', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.modals.save.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var modalsSave = {
        name: 'modals.save',
        url: '/modals/save',
        views: {
          "main": {
            controller: 'ModalsSaveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/modals/save/save.tpl.html'
          }
        },
        data: {
          pageTitle: '   '
        }
      };

    $stateProvider
      .state(modalsSave);
});
